import React from "react";
import PropTypes from "prop-types";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import EducationHeader from "stream/components/EducationHeader";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";

export default function EducationSectionStream(props) {
  return (
    <SectionStreamWrapper {...props} slug={props.match.params.section}>
      {({ streamParams }) => {
        return (
          <>
            <EducationHeader />
            <Stream
              {...streamParams}
              contentComponent={FullStoryCard}
              onlyShowTitleForA11y={true}
            />
          </>
        );
      }}
    </SectionStreamWrapper>
  );
}

EducationSectionStream.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      section: PropTypes.string.isRequired,
    }),
  }),
};
